import React, { useEffect, useState } from "react";

//* import css
import cssClasses from "./LiveInventoryEvents.module.css";

//* imports MUI
import { Box, Modal, Typography } from "@mui/material";
import ViewMore from "../../Assets/Images/Common/viewMoreIcon.svg";
import eventIcon from "../../Assets/Images/Common/Browser.svg";

//* import subComponents
import Button from "../../Subcomponents/Button";
import Calendar from "../../Assets/Images/Common/calendar.svg";
import { Card } from "@mui/material";
//* import store
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import { dismissLoader, presentLoader } from "../../Services/loader";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../../Components/Icons/Dot";
import { getAllEventsForLiveInventory } from "../../Services/AssignNewToken";
import * as _ from "lodash";
import { useNavigate } from "react-router-dom";
import EmptyListIcon from "../../Assets/Images/Common/NoSiteVisitsFound.svg";
import { errorTost, offlineToast } from "../../Services/Toast";
import { Network } from "@capacitor/network";
import DropDown from "../../Subcomponents/DropDown";
import { getAllProjects, getLaunches } from "../../Services/FastBooking";

import Close from "../../Components/Icons/Close";
import { getAllUnits } from "../../Services/LiveInventory";
import CustomRadio from "../../Subcomponents/CustomRadio";
import SearchBar from "../../Subcomponents/Search";
import { getAllWingsForProjects } from "../../Services/SustenanceService";
import CustomInput from "../../Subcomponents/CustomInput";

function LiveInventoryEvents() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [eventsPresent, setEventsPresent] = useState(null);
  const [events, setEvents] = useState([]);
  const [type, setType] = useState("Event");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const [allProjects, setAllProjects] = useState([]);
  const [eventData, setEventData] = useState("");
  const [launchList, setLaunchList] = useState([]);
  const [allLaunches, setAllLaunches] = useState([]);
  const [selectedLaunch, setSelectedLaunch] = useState("");
  const [search, setSearch] = useState("");
  const [WingList, setWingList] = useState([]);
  const [selectedWing, setSelectedWing] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [wingFormat, setWingFormat] = useState("Single");
  const [launchFormat, setLaunchFormat] = useState("Single");
  const [searchProject, setSearchProject] = useState(false);
  const [FilterProjects, setFilterProjects] = useState([]);
  let [selectedWingArr, setSelectedWingArr] = useState([]);
  let [selectedLaunchArr, setSelectedLaunchArr] = useState([]);
  let wingsArr = [];
  const [closeDependency, setCloseDependency] = useState(null);
  const [startingFloor, setStartingFloor] = useState(1);
  const [endingFloor, setEndingFloor] = useState("");

  const handleClose = () => {
    setOpen(false);
    setCloseDependency(Math.random());
    setWingFormat("Single");
    setLaunchFormat("Single");
    setWingList([]);
  };

  const style = {
    position: "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "20%",
    height: "100",
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
  };
  useEffect(() => {
    dispatch(action.activeMenu("liveinventory"));
    if (type !== null) {
      setType(type);
      if (type === "Event") {
        getEvents();
      } else {
        document.getElementById(
          "input-with-icon-textfield StudentSearch"
        ).value = "";
        setSearch("");
        getProjects();
      }
    } else {
      setType("Event");
      getEvents();
    }
  }, [eventData, closeDependency]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    wingsArr = [...selectedWingArr];
  }, [selectedWingArr, selectedWing]);

  useEffect(() => {
    let updatedWingList = [];

    selectedLaunchArr.forEach((launchId) => {
      getAllUnits(launchId)
        .then((response99) => {
          const groupByWing = _.uniqBy(
            response99.data,
            (item) => `${item?.wingId?.wingId}_${item?.launchId?.launchId}`
          );
          updatedWingList = [...updatedWingList, ...groupByWing];
          setWingList(updatedWingList);
        })
        .catch((err) => {
          errorTost(err.message);
        });
    });

    setWingList((prevWingList) => {
      const filteredWingList = prevWingList.filter((wing) =>
        selectedLaunchArr.includes(wing?.launchId)
      );
      const uniqueWingList = _.uniqBy(
        [...filteredWingList, ...updatedWingList],
        "wingId?.wingId"
      );
      return uniqueWingList;
    });
  }, [selectedLaunchArr]);

  function getEvents() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getAllEventsForLiveInventory()
          .then((resp) => {
            resp.data = resp.data
              .filter(
                (f) =>
                  new Date(f.endDateTime).getTime() < new Date().getTime() ===
                  false
              )
              .map((el, index) => ({
                ...el,
                index: index,
                id: el.eventId,
                eventtitle: el.title,
              }));
            setEvents([...resp.data]);
            if (eventData) {
              getAllLaunches(eventData, resp.data[0].unitTypeDisplay, "");
            }
            setEventsPresent(resp.data.length > 0 ? true : false);
            dismissLoader();
          })
          .catch((err) => {
            errorTost(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }

  function getAllLaunches(eventId) {
    getLaunches(eventId)
      .then((resp) => {
        resp.data = resp.data.map((each) => ({
          ...each,
          label: each.title,
          value: each.launchId,
        }));
        setAllLaunches([...resp.data]);
        setLaunchList([...resp.data]);
        sessionStorage.setItem(
          "liveInventoryLaunchId",
          JSON.stringify(resp.data[0].launchId)
        );
        sessionStorage.setItem(
          "liveInventoryProjectId",
          JSON.stringify(resp.data[0].projectId.projectId)
        );
        setSelectedLaunch(resp.data[0].launchId);
        setSelectedLaunchArr([resp.data[0].launchId]);
        setSelectedProjectId(resp.data[0].projectId.projectId);
        getAllUnits(resp.data[0].launchId)
          .then((response99) => {
            const groupByWing = _.uniqBy(response99.data, "wingId.wingId");
            setWingList(groupByWing);
          })
          .catch((err) => {
            errorTost(err.message);
          });
      })
      .catch((err) => {
        errorTost(err.message);
      });
  }
  function getProjects() {
    getAllProjects()
      .then((resp) => {
        resp.data = resp.data.map((each) => ({
          ...each,
          label: each.projectName,
          value: each.projectId,
          isSelected: false,
        }));
        setAllProjects([...resp.data]);
        setFilterProjects([...resp.data]);
      })
      .catch((err) => {
        errorTost(err.message);
      });
  }

  function getSelectedWingsForProject(projectId) {
    getAllWingsForProjects(projectId)
      .then((wingsResp) => {
        const uniqueWings = _.uniqBy(wingsResp.data, "wingId.wingId");
        setWingList(uniqueWings);
        setSelectedProjectId(projectId);
      })
      .catch((err) => {
        console.error(err.message);
      });
  }

  function searchAndUpdateResults(val) {
    const searchTerm = val.toLowerCase();
    let filteredNames = FilterProjects;
    if (val !== "") {
      filteredNames = FilterProjects.filter((name) =>
        name.label.toLowerCase().includes(searchTerm)
      );
    }
    setAllProjects(filteredNames);
  }

  const debouncedFetchSearchData = _.debounce((e) => {
    setSearch(e.target.value);
    searchAndUpdateResults(e.target.value);
  }, 800);

  return (
    <>
      <div className={cssClasses.wrapperPage}>
        <Box className={cssClasses.headerWrapper}>
          <Box className={cssClasses.headerLeftSide}>
            <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
              <Typography className={cssClasses.headerTittle}>
                Live Inventory
              </Typography>
            </Box>
          </Box>
        </Box>

        <div className={cssClasses.mainWrapper}>
          <Box margin={"2rem 0"} width={"100%"}>
            <div className={cssClasses.blockLabel}>
              Select Type <span style={{ color: "red" }}> *</span>
            </div>
            <Box className={cssClasses.SubContainer} marginTop={"0.4rem"}>
              <Box className={cssClasses.wrapperSortBy}>
                <Box className={cssClasses.wrapperSortBy}>
                  <DropDown
                    list={["Event", "Project"]}
                    selectedValue={type}
                    onChangeSelect={(value) => {
                      setType(value);
                      if (value === "Event") {
                        getEvents();
                      } else {
                        setSearchProject(true);
                        getProjects();
                      }
                    }}
                    placeHolder={"Select"}
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                  />
                </Box>
              </Box>
              {searchProject && (
                <Box width={"25rem"} marginLeft={"auto"}>
                  <SearchBar
                    id={"StudentSearch"}
                    value={search}
                    placeholder={"Search by project name"}
                    search={debouncedFetchSearchData}
                  />
                </Box>
              )}
            </Box>
          </Box>
          {eventsPresent && type === "Event" && (
            <div className={cssClasses.eventsWrapper}>
              {events.map((event) => (
                <Card className={cssClasses.eventWrap} key={event.eventId}>
                  <div className={cssClasses.eventInfo}>
                    <div className={cssClasses.eventImg}>
                      {event && event.bannerImgUrl ? (
                        <img
                          src={
                            process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                            event.bannerImgUrl
                          }
                          alt="Event"
                        />
                      ) : (
                        <div
                          style={{
                            background: "#FDB022",
                            borderRadius: "50%",
                            textAlign: "center",
                          }}
                        >
                          <img
                            style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                            src={eventIcon}
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                    <div className={cssClasses.eventData}>
                      {event.startDateTime < Date.now() &&
                      event.endDateTime > Date.now() ? (
                        <LeadStatusChip
                          label={"Live event"}
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#027A48",
                            backgroundColor: "#ECFDF3",
                          }}
                        ></LeadStatusChip>
                      ) : (
                        <LeadStatusChip
                          label={"Upcoming"}
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#B54708",
                            backgroundColor: "#FFFAEB",
                          }}
                        ></LeadStatusChip>
                      )}

                      <div className={cssClasses.eventName}>
                        {event.eventtitle}
                      </div>
                      <div className={cssClasses.eventLaunches}></div>
                      <div className={cssClasses.eventDate}>
                        <div className={cssClasses.launchIcon}>
                          <img src={Calendar} alt="Event Schedule" />
                        </div>
                        <div className={cssClasses.launchLoc}>
                          From{" "}
                          <span className={cssClasses.bold}>
                            {new Date(event.startDateTime).toDateString()},{" "}
                            {new Date(event.startDateTime).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>{" "}
                          to{" "}
                          <span className={cssClasses.bold}>
                            {new Date(event.endDateTime).toDateString()},{" "}
                            {new Date(event.endDateTime).toLocaleTimeString(
                              [],
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        </div>
                      </div>
                      <div className={cssClasses.viewMore}>
                        <img
                          src={ViewMore}
                          style={{ cursor: "pointer" }}
                          alt={"More"}
                          onClick={() => {
                            sessionStorage.setItem(
                              "selectedType",
                              JSON.stringify("Event")
                            );
                            handleOpen();
                            setEventData(event.eventId);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          )}
          {eventsPresent === false && type === "Event" && (
            <div className={cssClasses.noDataMsg}>
              <div className={cssClasses.emptyIcon}>
                <img src={EmptyListIcon} alt="No Live Events" />
              </div>
              <div className={cssClasses.emptyTitle}>No Live Events Found</div>
            </div>
          )}
          {type === "Project" && (
            <div className={cssClasses.eventsWrapper}>
              {allProjects.length > 0 &&
                allProjects.map((project) => (
                  <Card className={cssClasses.eventWrap}>
                    <div className={cssClasses.eventInfo}>
                      <div className={cssClasses.eventImg}>
                        {project && project.bannerImgUrl ? (
                          <img
                            src={
                              process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                              project.bannerImgUrl
                            }
                            alt="Event"
                          />
                        ) : (
                          <div
                            style={{
                              background: "#FDB022",
                              borderRadius: "50%",
                              textAlign: "center",
                            }}
                          >
                            <img
                              style={{ margin: "0.8rem 1rem 0.4rem 1rem" }}
                              src={eventIcon}
                              alt=""
                            />
                          </div>
                        )}
                      </div>
                      <div className={cssClasses.eventData}>
                        <LeadStatusChip
                          label={
                            project.isCompleted ? "Completed" : "Incomplete"
                          }
                          icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          style={{
                            color: "#027A48",
                            backgroundColor: "#ECFDF3",
                          }}
                        ></LeadStatusChip>

                        <div className={cssClasses.eventName}>
                          {project.projectName}
                        </div>
                        <div className={cssClasses.eventLaunches}></div>
                        <div className={cssClasses.eventDate}>
                          <div className={cssClasses.eventLaunches}>
                            <p>{`${project.addressLine1} ${
                              project.addressLine2
                            } ${
                              project.addressLine3 === null
                                ? ""
                                : project.addressLine3
                            }`}</p>
                          </div>
                        </div>
                        <div className={cssClasses.viewMore}>
                          <img
                            src={ViewMore}
                            style={{ cursor: "pointer" }}
                            alt={"More"}
                            onClick={() => {
                              getSelectedWingsForProject(project.projectId);
                              handleOpen();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
              {allProjects.length === 0 && (
                <>
                  <Box width={"100%"} height={"100%"}>
                    <div className={cssClasses.noDataMsg}>
                      <div className={cssClasses.emptyIcon}>
                        <img src={EmptyListIcon} alt="No Inventory" />
                      </div>
                      <div className={cssClasses.emptyTitle}>
                        No Project Found
                      </div>
                    </div>
                  </Box>
                </>
              )}
            </div>
          )}

          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Box className={cssClasses.headerDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.flexCol}>
                    <Box className={cssClasses.flexRow}>
                      <Box className={cssClasses.HeaderTitle}>Event Info:</Box>{" "}
                    </Box>
                    <Box className={cssClasses.bhkTitle}></Box>
                  </Box>
                  <Box
                    ml={"auto"}
                    mt={1}
                    onClick={handleClose}
                    style={{ cursor: "pointer" }}
                  >
                    <Close width={"1.2rem"} height={"1.2rem"} />
                  </Box>
                </Box>
              </Box>

              <Box width={"100%"} height={"85%"} overflow={"auto"}>
                <Box margin={"1.5rem 3.2rem"}>
                  <Box className={cssClasses.ThirdDiv}>
                    {type === "Event" && (
                      <>
                        <Box className={cssClasses.ThirdDiv}>
                          <Box className={cssClasses.InputTitle} mt={1.5}>
                            Select Launch Format :{" "}
                          </Box>
                          <Box className={cssClasses.widthBox}>
                            <CustomRadio
                              optionList={["Single", "Multiple"]}
                              value={launchFormat}
                              onChangeValue={(e) => {
                                setLaunchFormat(e);
                                sessionStorage.setItem("launchFormat", e);
                                if (e === "Multiple") {
                                  setSelectedLaunch("All");
                                }
                              }}
                            />
                          </Box>
                          <Box className={cssClasses.InputTitle}>
                            Select Launch :{" "}
                          </Box>
                          <Box className={cssClasses.widthBox}>
                            {launchFormat === "Single" ? (
                              <DropDown
                                list={allLaunches}
                                selectedValue={selectedLaunch}
                                onChangeSelect={(_value) => {
                                  setSelectedLaunch(_value);
                                  sessionStorage.setItem(
                                    "liveInventoryLaunchId",
                                    JSON.stringify(_value)
                                  );
                                  let launches = allLaunches.filter(
                                    ({ launchId }) => launchId === _value
                                  );
                                  sessionStorage.setItem(
                                    "liveInventoryProjectId",
                                    JSON.stringify(
                                      launches[0].projectId.projectId
                                    )
                                  );
                                  setSelectedProjectId(
                                    launches[0].projectId.projectId
                                  );
                                  getAllUnits(_value)
                                    .then((response99) => {
                                      const groupByWing = _.uniqBy(
                                        response99.data,
                                        "wingId.wingId"
                                      );
                                      setWingList(groupByWing);
                                    })
                                    .catch((err) => {
                                      errorTost(err.message);
                                    });
                                }}
                                helperText=""
                                style={{
                                  background: "#F2F4F7",
                                  color: "rgb(102, 112, 133)",
                                }}
                                placeHolder="Select Launch"
                              ></DropDown>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  gap: "1rem",
                                  marginTop: "1rem",
                                  marginBottom: "1rem",
                                  maxHeight: "12rem",
                                  overflow: "auto",
                                }}
                              >
                                {launchList.map((launch) => (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      flexDirection: "row",
                                      gap: "1rem",
                                    }}
                                  >
                                    <input
                                      className={cssClasses.checkbox}
                                      type="checkbox"
                                      name=""
                                      id={launch?.launchId}
                                      style={{ cursor: "pointer" }}
                                      onChange={(e) => {
                                        if (
                                          selectedLaunchArr.includes(
                                            launch?.launchId
                                          )
                                        ) {
                                          setSelectedLaunchArr(
                                            (prevSelectedLaunchArr) =>
                                              prevSelectedLaunchArr.filter(
                                                (id) => id !== launch?.launchId
                                              )
                                          );
                                        } else {
                                          setSelectedLaunchArr(
                                            (prevSelectedLaunchArr) => [
                                              ...prevSelectedLaunchArr,
                                              launch?.launchId,
                                            ]
                                          );
                                        }
                                      }}
                                      checked={
                                        selectedLaunchArr?.includes(
                                          launch?.launchId
                                        )
                                          ? true
                                          : false
                                      }
                                    />
                                    <label
                                      htmlFor={launch?.launchId}
                                      className={cssClasses.toggleLabel}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {launch?.title}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            )}
                          </Box>
                        </Box>
                      </>
                    )}

                    <Box className={cssClasses.InputTitle} mt={1.5}>
                      Select Wing Format :{" "}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      <CustomRadio
                        optionList={["Single", "Multiple"]}
                        value={wingFormat}
                        onChangeValue={(e) => {
                          setWingFormat(e);
                          sessionStorage.setItem("wingFormat", e);
                          if (e === "Multiple") {
                            setSelectedWing("All");
                          }
                        }}
                      />
                    </Box>
                    <Box className={cssClasses.InputTitle} mt={1.5}>
                      Select Wing :{" "}
                    </Box>
                    <Box className={cssClasses.widthBox}>
                      {wingFormat === "Single" ? (
                        <DropDown
                          placeHolder={"Select"}
                          list={WingList.map((element, _id) => {
                            return {
                              label: element.wingId.displayName
                                ? element.wingId.displayName
                                : element.wingId.wingName,
                              value: element.wingId.wingId,
                            };
                          })}
                          selectedValue={selectedWing}
                          onChangeSelect={(value) => {
                            setSelectedWing(value);
                            sessionStorage.setItem(
                              "liveInventoryWIngId",
                              JSON.stringify(value)
                            );
                            let wings = WingList.filter(
                              ({ wingId }) => wingId === value
                            );
                          }}
                          style={{
                            background: "#F2F4F7",
                            selectedColor: "#667085",
                          }}
                          disable={
                            type === "Event" ? selectedLaunch === "" : false
                          }
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "1rem",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                            maxHeight: "12rem",
                            overflow: "auto",
                          }}
                        >
                          {WingList.map((wing) => (
                            <div
                              key={`${wing.wingId.wingId}`}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                flexDirection: "row",
                                gap: "1rem",
                              }}
                            >
                              <input
                                className={cssClasses.checkbox}
                                type="checkbox"
                                name=""
                                id={`${wing.wingId.wingId}`}
                                style={{ cursor: "pointer" }}
                                onChange={(e) => {
                                  const id = `${wing.wingId.wingId}`;
                                  if (selectedWingArr.includes(id)) {
                                    setSelectedWingArr((pre) =>
                                      pre.filter(
                                        (selectedId) => selectedId !== id
                                      )
                                    );
                                  } else {
                                    setSelectedWingArr((pre) => [...pre, id]);
                                  }
                                }}
                                checked={selectedWingArr?.includes(
                                  `${wing.wingId.wingId}`
                                )}
                              />
                              <label
                                htmlFor={wing.wingId.wingId}
                                className={cssClasses.toggleLabel}
                                style={{ cursor: "pointer" }}
                              >
                                {wing.wingId.displayName
                                  ? wing.wingId.displayName
                                  : wing.wingId.wingName}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                    </Box>

                    {type === "Project" && (
                      <>
                        {/* Add starting and ending floor number input fields */}
                        <Box className={cssClasses.InputTitle} mt={2}>
                          Starting Floor No :
                        </Box>
                        <Box className={cssClasses.widthBox}>
                          <CustomInput
                            type="number"
                            value={startingFloor || 1}
                            handleChange={(_value) => {
                              if (!isNaN(_value)) {
                                setStartingFloor(1);
                              }
                            }}
                            placeholder="Enter starting floor"
                            disabled={true}
                            style={{
                              padding: "0.5rem",
                              width: "100%",
                              backgroundColor: "#F2F4F7",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        </Box>

                        <Box className={cssClasses.InputTitle} mt={2}>
                          Ending Floor No :
                        </Box>
                        <Box className={cssClasses.widthBox}>
                          <CustomInput
                            inputType="number"
                            value={endingFloor}
                            // handleChange={(e) => setEndingFloor(e.target.value)}
                            handleChange={(_value) => {
                              console.log(_value);
                              // Check if the value is empty, a number, and within the valid range
                              if (!isNaN(_value) && _value <= 50) {
                                setEndingFloor(_value); // Set the value if it's valid
                              }
                            }}
                            placeholder="Enter ending floor"
                            style={{
                              padding: "0.5rem",
                              width: "100%",
                              backgroundColor: "#F2F4F7",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          />
                        </Box>
                      </>
                    )}
                  </Box>
                </Box>
              </Box>

              <Box className={cssClasses.FooterDiv}>
                <Box className={cssClasses.flexRow}>
                  <Box width={"fit-Content"} ml={"auto"}>
                    <Button
                      style={{
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        color: "#344054",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "0.4rem",
                      }}
                      padding={"0.6rem 2rem"}
                      btnName={"Cancel"}
                      clicked={handleClose}
                    />
                  </Box>

                  <Box width={"fit-Content"}>
                    <Button
                      style={{
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        color: "#FFF",
                        backgroundColor: "#007FFF",
                        borderRadius: "0.4rem",
                      }}
                      padding={"0.6rem 2rem"}
                      btnName={"Go"}
                       disable={
                        (wingFormat === "Single"
                          ? selectedWing === ""
                          : selectedWingArr.length === 0) ||
                        endingFloor === "" ||
                        isNaN(endingFloor) ||
                        parseInt(endingFloor) <= 0
                      }
                      clicked={() => {
                        const wingIds = selectedWingArr.map(
                          (combinedId) => combinedId.split("_")[0]
                        );
                        sessionStorage.setItem(
                          "selectedWings",
                          JSON.stringify(wingIds)
                        );
                        if (type === "Event") {
                          sessionStorage.setItem(
                            "selectedType",
                            JSON.stringify("Event")
                          );
                          sessionStorage.setItem(
                            "selectedLaunches",
                            JSON.stringify(selectedLaunchArr)
                          );
                          navigate(
                            `/home/liveInventory/${eventData}/${selectedLaunch}/${selectedWing}/${selectedProjectId}`
                          );
                        } else {
                          sessionStorage.setItem(
                            "selectedType",
                            JSON.stringify("Project")
                          );
                          navigate(
                            `/home/liveInventory/${selectedWing}/${selectedProjectId}`,{
                              state: { startingFloor: startingFloor, endingFloor: endingFloor } 
                            }
                          );
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default LiveInventoryEvents;
